import * as React from "react";
import { Input } from "@/shared/components/ui/input";
import { MagicFillFieldButton } from "./MagicFillFieldButton";
import { MagicFillFormType, MagicFillMetadata } from "./MagicFillButton";
import { cn } from "@/infrastructure/lib/utils";
import { useMagicFill } from "@/shared/contexts/MagicFillContext";

export interface InputWithMagicFillProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  formType: MagicFillFormType;
  fieldKey: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCurrentValues: () => Record<string, any>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMagicFillApply: (value: any) => void;
  onLoadingChange?: (isLoading: boolean) => void;
  metadata?: MagicFillMetadata;
  showMagicFill?: boolean;
}

export const InputWithMagicFill = React.forwardRef<
  HTMLInputElement,
  InputWithMagicFillProps
>(
  (
    {
      formType,
      fieldKey,
      getCurrentValues,
      onMagicFillApply,
      onLoadingChange,
      metadata,
      showMagicFill = true,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const { isGlobalLoading, isFieldLoading } = useMagicFill();
    const isLoading = isGlobalLoading || isFieldLoading(fieldKey);

    return (
      <div className="relative">
        <Input
          ref={ref}
          fieldKey={fieldKey}
          className={cn("pr-10", className)}
          disabled={disabled}
          {...props}
        />
        {showMagicFill && !disabled && !isLoading && (
          <MagicFillFieldButton
            formType={formType}
            fieldKey={fieldKey}
            getCurrentValues={getCurrentValues}
            metadata={metadata}
            onApplySuggestion={onMagicFillApply}
            onLoadingChange={onLoadingChange}
          />
        )}
      </div>
    );
  }
);

InputWithMagicFill.displayName = "InputWithMagicFill";
